__webpack_require__.p = "/ebankingwebuk/";